import { SavedStatus } from './reducer'
export enum SavedActionTypes {
  UPDATE_SAVED = 'UPDATE_SAVED',
}

export const updateSaved = (saved: SavedStatus) => ({
  type: SavedActionTypes.UPDATE_SAVED,
  saved,
})
